const gridProfile = {
  gridProfile: {
    pageHeader: 'Rasterprofiel',
    name: 'Naam',
    description: 'Beschrijving',
    createdBy: 'Aangemaakt door',
    noGrid: '** Geen rasters beschikbaar **',
    grids: 'Rasters'
  }
};

export default gridProfile;
